export const chargeServicesDrawer = {
  title: "Opłaty i usługi",
  closeAria: "Zamknij",
  subtitle: {
    catalog: "Katalog wielokrotnego użytku do faktur",
    select: "Proszę wybrać pozycje do dodania",
  },
  searchPlaceholder: "Szukaj usługi…",
  createService: "Utwórz usługę",
  loading: "Wczytywanie usług…",
  empty: "Nie ma tu jeszcze żadnych usług. Proszę utworzyć pierwszą.",
  item: {
    vat: "VAT {vat}%",
    edit: "Edytuj",
    delete: "Usuń",
  },
  footer: {
    selected: "{count} zaznaczona | {count} zaznaczone | {count} zaznaczonych",
    createInvoice: "Utwórz fakturę z tych pozycji",
    addToInvoice: "Dodaj do faktury",
  },
  form: {
    editTitle: "Edytuj usługę",
    newTitle: "Nowa usługa",
    subtitle: "Pozycja wielokrotnego użytku do faktur",
    photoLabel: "Zdjęcie",
    optional: "opcjonalnie",
    uploadPhoto: "Wgraj",
    nameLabel: "Nazwa",
    namePlaceholder: "np. Sprzątanie końcowe",
    categoryLabel: "Kategoria",
    categoryPlaceholder: "np. Sprzątanie",
    priceLabel: "Cena",
    vatLabel: "VAT",
    descriptionLabel: "Opis",
    descriptionPlaceholder: "Szczegóły widoczne na fakturze",
    cancel: "Anuluj",
    save: "Zapisz zmiany",
    create: "Utwórz usługę",
  },
  toasts: {
    loadError: "Nie udało się wczytać usług.",
    photoError: "Nie udało się wgrać zdjęcia.",
    updated: "Usługa zaktualizowana.",
    created: "Usługa utworzona.",
    saveError: "Nie udało się zapisać usługi.",
    deleteError: "Nie udało się usunąć.",
  },
  confirmDelete: 'Usunąć „{name}” z katalogu?',
};
